import { ApiResponse } from '@/services';
import request from '@/utils/request';

/**
 * 使用兑换码 / 优惠券
 * @param data
 * @returns
 */
export const exchangeCode = async <T>(
  exchangeCode: string,
  fromRegister: boolean = false,
): Promise<ApiResponse<T>> => {
  const res = await request('/api/rest/dlt/user/right/consume/exchangeCode', {
    method: 'POST',
    data: {
      exchangeCode,
      fromRegister,
    },
  });
  return res;
};

export type CouponList = {
  couponCode: string; // 优惠券码
  couponName?: string; // 优惠券名称
  status: 1 | 2 | 3; // 1:未使用 2:已使用 3:已过期
  applicableGoods: string[]; // 适用的会员商品ID
  effectStartTime?: number; // 使用的开始时间
  effectEndTime?: number; // 使用的结束时间
  useTime?: number; // 使用时间
  type: 1 | 2; // 1：折扣券 2:立减券
  content: number; // 优惠内容（金额/折扣）
  isValidityPeriod: boolean; // 是否在使用期内
  activityId?: number; // 活动ID
  mode?: 0 | 1 | 2; // 0:领取 1:新用户专享 2:basicVip升级差价
  // 新用户折扣剩余倒计时秒数
  leftSeconds?: number;
}[];

/**
 * 获取用户当前的所有优惠券
 * @param data
 * @returns
 */
export const getUserCoupon = async <T>(): Promise<ApiResponse<T>> => {
  const res = await request('/api/rest/dlt/user/coupon', {
    method: 'POST',
  });
  return res;
};

/**
 * 取消用户当前使用的优惠券
 */

export const cancelUserCoupon = async <T>(coupon: string): Promise<ApiResponse<T>> => {
  const res = await request('/api/rest/dlt/user/coupon/cancel', {
    method: 'POST',
    data: {
      coupon,
    },
  });
  return res;
};
